import Button from 'components/form/Button';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { icons } from 'utils/constants';
import { getUserType } from 'utils/helpers';
import { getEventProcessData } from 'store/slices';
import usePermission from 'hooks/usePermission';

const labelMap = {
  events: 'Events',
  acceptance_letterhead: 'Acceptance Letterhead',
  important_dates: 'Important Dates',
  committee_member: 'Committee Member',
  speaker: 'Speaker',
  registration: 'Registration',
  add_on_service: 'Add-On Services',
  agenda: 'Agenda',
  past_conferences_gallery: 'Past Conferences Gallery',
  instant_pass: 'Instant Pass',
};

const EventProcessSideSection = ({
  tabOrder = [],
  isViewMode,
  event_id,
  type,
  isTemp,
  requestProcessFlowData,
  editBtnAccess,
}) => {
  const params = useParams();
  const { requestType, eventId } = params;
  const memberType = getUserType();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const path = window.location.pathname;
  const eventPath = path.split('/');
  const targetValue = eventPath[2] || '';

  const permissionMapping = {
    'event-management': 'Event Management',
    'raised-request': 'Requests',
    'request-received': 'Requests',
  };
  const permissionName = permissionMapping[targetValue] || '';
  const { viewAccess, createAccess, updateAccess, deleteAccess } = usePermission(permissionName);

  const [processFlowData, setProcessFlowData] = useState({});

  useEffect(() => {
    if (requestProcessFlowData) {
      setProcessFlowData(requestProcessFlowData);
    }
  }, [requestProcessFlowData]);

  const fetchEventDetails = async () => {
    const temp_id = isTemp ? `&temp_id=${isTemp}` : '';
    const response = await dispatch(getEventProcessData(eventId, temp_id));
    if (response.status === 200) {
      setProcessFlowData(response.data.event_process_bar);
    }
  };

  useEffect(() => {
    if (!requestProcessFlowData && eventId !== 'add-event') {
      fetchEventDetails();
    }
  }, [type]);

  return (
    <div className="cpt-20">
      {isViewMode && updateAccess === '1' && editBtnAccess && (
        <div className="d-flex justify-content-end cpe-20 cmb-18">
          <Button
            icon={
              <img
                src={icons.PrimaryEdit}
                alt=""
                style={{
                  marginRight: '8px',
                }}
              />
            }
            btnStyle="primary-outline1"
            className="cps-12 cpe-12 h-30"
            text="Edit Event"
            onClick={() => {
              navigate(
                `/${memberType}/${requestType}/event-management/events/edit-event/${event_id}`
              );
            }}
          />
        </div>
      )}
      <div>
        <div className="text-16-400-20">Event Process:</div>
        <ul
          style={{ listStyleType: 'none', paddingLeft: 0 }}
          className="cmt-17"
        >
          {tabOrder.map((tab, index) => {
            const isCompleted = processFlowData?.[tab] === true;
            const iconSrc = isCompleted
              ? icons?.abstractDone
              : icons?.ClockPending;

            return (
              <li
                key={tab}
                style={{ display: 'flex', alignItems: 'flex-start' }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={iconSrc}
                    alt={isCompleted ? 'Completed' : 'Pending'}
                    height={24}
                    width={24}
                  />
                  {index < tabOrder.length - 1 && (
                    <div
                      style={{
                        width: '2px',
                        flexGrow: 1,
                        borderLeft: '2px dashed #ccc',
                        margin: '2px auto',
                        height: '15px',
                      }}
                    />
                  )}
                </div>

                <div className="text-14-500-18 cmb-10 cms-10 ">
                  {labelMap[tab]}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default EventProcessSideSection;
